import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Text,
} from '@billda/design-system';
import type { FC } from 'react';

interface ConfirmAddLabourItemDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  labourItemName?: string;
  plotName?: string;
  plotNumber?: string;
}

/**
 * Confirmation dialog for adding a labour item to a plot
 * Shows before submission to confirm the details
 */
export const ConfirmAddLabourItemDialog: FC<
  ConfirmAddLabourItemDialogProps
> = ({ open, onClose, onConfirm, labourItemName, plotName, plotNumber }) => {
  return (
    <Dialog open={open} onOpenChange={isOpen => !isOpen && onClose()}>
      <DialogContent className="max-w-sm sm:max-w-md">
        <DialogHeader>Confirm Add Labour Item</DialogHeader>
        <DialogBody>
          <Text variant="body1">
            Add <strong>{labourItemName || 'this labour item'}</strong> to{' '}
            <strong>
              {plotName} ({plotNumber})
            </strong>
            ?
          </Text>
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="neutral" onClick={onConfirm}>
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
